import { Link, Typography } from "@podcastsoundboard/ps-lib/ui"

const Copyright = (props: { className?: string } = {}) => {
  const currentYear = new Date().getFullYear()

  const content = (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://podcastsoundboard.com/">
        Podcast Soundboard
      </Link>{" "}
      {currentYear}
    </Typography>
  )

  return content
}

export default Copyright
